module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-drinks-16c9235340c3fa0a073931adfc4ebc19.png";